<template>
  <div>apply</div>
</template>

<script>
export default {
  name: "apply"
}
</script>

<style scoped>

</style>